import { render, staticRenderFns } from "./BalancesSelfTransactions.vue?vue&type=template&id=586c25f8&"
import script from "./BalancesSelfTransactions.vue?vue&type=script&lang=ts&"
export * from "./BalancesSelfTransactions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports